import React, { useState } from 'react';
import Banner from './components/Banner';
import Contact from './components/Contact';
import Header from './components/Header';
import Resume from './components/Resume';
import Services from './components/Services';
import SocialLinks from './components/SocialLinks';
import Work from './components/Work';
import napis from './assets/demo/optimized/napis.webp';

const App = () => {
  const [selectedService, setSelectedService] = useState('');
  const [selectedTrickRequest, setSelectedTrickRequest] = useState(null);
  const [selectedShowRequest, setSelectedShowRequest] = useState(null);
  const [selectedVideoRequest, setSelectedVideoRequest] = useState(null);

  const handleSelectTrick = (itemId) => {
    setSelectedTrickRequest((request) => ({
      itemId,
      requestId: (request?.requestId ?? 0) + 1,
    }));
  };

  const handleSelectShow = (itemId) => {
    setSelectedShowRequest((request) => ({
      itemId,
      requestId: (request?.requestId ?? 0) + 1,
    }));
  };

  const handleSelectVideo = (itemId) => {
    setSelectedVideoRequest((request) => ({
      itemId,
      requestId: (request?.requestId ?? 0) + 1,
    }));
  };

  return (
    <div className='min-h-screen overflow-x-hidden bg-primary text-white'>
      <Header />
      <main>
        <Banner />
        <Services onSelectService={setSelectedService} />
        <Resume
          onSelectTrick={handleSelectTrick}
          onSelectShow={handleSelectShow}
          onSelectVideo={handleSelectVideo}
        />
        <Work
          selectedTrickRequest={selectedTrickRequest}
          selectedShowRequest={selectedShowRequest}
          selectedVideoRequest={selectedVideoRequest}
        />
        <Contact
          selectedService={selectedService}
          onSelectedServiceChange={setSelectedService}
        />
      </main>
      <footer className='py-8 text-center text-sm text-white/25'>
        <img
          className='mx-auto mb-5 h-10 w-auto object-contain'
          src={napis}
          alt='Action Fifi'
        />
        <SocialLinks className='mb-5 justify-center' />
        <p>Copyright 2026. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default App;
